import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import Icon from '../../utils/Icon';
import Ripple from '../../utils/Ripple';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
import styles from './PanelButton.scss';
const PanelButton = ({ title = '', tooltipTitle = '', onClick, className = '', hasWrapper = false, isDisabled = false, icon, badge, type, dataCy, src, iconClassName, }) => {
    const resolvedTooltipTitle = useHelpNoteTitle(title, tooltipTitle);
    const handleClick = useCallback(e => {
        e.preventDefault();
        if (!isDisabled) {
            onClick && onClick();
        }
    }, [onClick, isDisabled]);
    const renderButton = useMemo(() => (<Ripple>
        <a className={classnames('legitRipple', styles.actionButton)}>
          <Icon badge={badge} className={classnames(styles.iconColor, iconClassName)} hoverTitle={resolvedTooltipTitle || title} isDisabled={isDisabled} name={icon} src={src} type={type}/>
        </a>
      </Ripple>), [
        type,
        icon,
        title,
        resolvedTooltipTitle,
        badge,
        isDisabled,
        src,
        iconClassName,
    ]);
    if (hasWrapper) {
        return renderButton;
    }
    return (<div className={classnames(className, styles.iconPosition)} data-cy={dataCy} title={resolvedTooltipTitle || title} onClick={handleClick}>
      {renderButton}
    </div>);
};
export default PanelButton;
